import {Palette} from 'hubbl-shared';
import {memo} from 'react';
import styled from 'styled-components';
import {TextHeading5} from '../text/TextHeading5';
import {TextHeading6} from '../text/TextHeading6';

interface InfoBitProps {
  label: string;
  value: string;
}

export const InfoBit = memo(({label, value}: InfoBitProps) => {
  return (
    <InfoBitContainer>
      <InfoBitLabel>
        <TextHeading6 text={label} color={Palette.almostBlack500} />
      </InfoBitLabel>
      <div>
        <TextHeading5 text={value} color={Palette.almostBlack} />
      </div>
    </InfoBitContainer>
  );
});

const InfoBitContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-bottom: 16px;
`;

const InfoBitLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
